import { SpacerNew, email, mobileNumber, required } from '@jfs/ui-new'
import { notRequired, optionalEmail } from '@jfs/ui-new/src/utils/validations'
import { TitleWithDashedLine } from '../../../../components/TitleWithDashedLine'
import { DropdownWithInfo } from '../comps/DropdownWithInfo'
import { TextInputWithInfo } from '../comps/TextInputWithInfo'
import { getDropdownData } from './dropdownData'
import { styles } from './styles'
import { Name } from './validations'

const shouldHideSelectStatus = (values) => !['UPDATE_PROFILE', 'RISK_UPDATE_PROFILE'].includes(values?.requestType)
const shouldHideReasonCode = (values) =>
  !['UPDATE_PROFILE', 'RISK_UPDATE_PROFILE'].includes(values?.requestType) || values?.status != 'TERMINATED'

export const personalDetailForm = (
  entityLovs: any[],
  editable: boolean,
  isStoreMerchant: boolean,
  isProfileUpdate: boolean,
) => ({
  key: 'PERSONAL_DETAILS_FORM',
  verticalFlex: 1,
  contentOverflow: 'auto',
  contentPadding: 24,
  horizontalFlex: 1,
  title: 'Business Contact',
  formItems: [
    {
      horizontalComps: [
        {
          fieldName: 'personalFirstName',
          ComponentName: TextInputWithInfo,
          label: 'First Name',
          placeholder: 'First Name',
          validationSchema: !isProfileUpdate ? Name : notRequired,
          ...styles.textinputStyle(editable && !isProfileUpdate),
          testID: 'personalFirstName',
        },
        {
          fieldName: 'personalLastName',
          ComponentName: TextInputWithInfo,
          label: 'Last Name',
          placeholder: 'Last name',
          validationSchema: !isProfileUpdate ? Name : notRequired,
          ...styles.textinputStyle(editable && !isProfileUpdate),
          testID: 'personalLastName',
        },
      ],
    },
    {
      horizontalComps: [
        {
          fieldName: 'personalMobileNumber',
          ComponentName: TextInputWithInfo,
          label: 'Mobile Number',
          placeholder: '10 digit mobile number',
          validationSchema: !isProfileUpdate ? mobileNumber : notRequired,
          ...styles.textinputStyle(editable && !isProfileUpdate),
          testID: 'personalMobileNumber',
        },
        {
          fieldName: 'personalEmailId',
          ComponentName: TextInputWithInfo,
          label: 'Email id',
          placeholder: 'yourmail@mail.com',
          validationSchema: isStoreMerchant || isProfileUpdate ? optionalEmail : email,
          ...styles.textinputStyle(editable && !isProfileUpdate),
          testID: 'personalEmailId',
        },
      ],
      horizontalSpacing: 8,
    },
    {
      fieldName: 'spacer',
      ComponentName: SpacerNew,
      size: 16,
    },
    {
      horizontalComps: [
        {
          fieldName: 'title',
          ComponentName: TitleWithDashedLine,
          title: 'Business Details',
        },
        // {
        //   fieldName: 'businessDetailsLine',
        //   ComponentName: Text,
        //   style: { flex: 1, textAlign: 'center', borderBottomWidth: 1, borderBottomColor: '#000' },
        //   title: '-',
        // },
      ],
    },
    {
      horizontalComps: [
        {
          fieldName: 'entityType',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          validationSchema: isStoreMerchant ? notRequired : required,
          label: 'Business Type',
          title: 'Select your business type',
          data: getDropdownData(entityLovs, 'OwnerType'),
          dataFieldToRead: 'description',
          testID: 'entityType',
        },
        {
          fieldName: 'ownershipType',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          validationSchema: isStoreMerchant ? notRequired : required,
          label: 'Business Ownership',
          title: 'Select  business ownership type',
          data: getDropdownData(entityLovs, 'OwnershipType'),
          dataFieldToRead: 'description',
          testID: 'ownershipType',
        },
        {
          fieldName: 'businessChannel',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          validationSchema: isStoreMerchant ? notRequired : required,
          label: 'Business Channel',
          title: 'Select Business Channel',
          data: getDropdownData(entityLovs, 'BusinessChannel'),
          dataFieldToRead: 'description',
          testID: 'ownershipType',
        },
      ],
      horizontalSpacing: 8,
    },
    {
      fieldName: 'spacer1',
      ComponentName: SpacerNew,
      size: 16,
    },
    {
      fieldName: 'title',
      hide: !isProfileUpdate,
      ComponentName: TitleWithDashedLine,
      title: 'Status',
    },
    {
      horizontalComps: [
        {
          fieldName: 'status',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          label: 'Status',
          title: 'Select Status',
          hideComponent: shouldHideSelectStatus,
          data: getDropdownData(entityLovs, 'Status'),
          dataFieldToRead: 'description',
        },
        {
          fieldName: 'reasonCode',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          validationSchema: isStoreMerchant ? notRequired : required,
          label: 'Reason Code',
          title: 'Select  reason code',
          hideComponent: shouldHideReasonCode,
          data: getDropdownData(entityLovs, 'ReasonCode'),
          dataFieldToRead: 'description',
        },
        {
          fieldName: 'reasonMessage',
          ComponentName: TextInputWithInfo,
          label: 'Reason Message',
          validationSchema: isStoreMerchant ? notRequired : required,
          hideComponent: shouldHideReasonCode,
          placeholder: 'select reason message',
          ...styles.textinputStyle(editable),
          disabled: !editable,
          editable,
        },
      ],
      horizontalSpacing: 8,
    },
  ],
  onSubmit: async (values) => {},
})
